var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8352 8H15.8501L12.4478 10.8125H14.4329L17.8352 8Z",
    fill: "var(--ion-color-secondary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2658 8H19.2525L15.8501 10.8125H17.8352L21.2658 8Z",
    fill: "var(--ion-color-secondary)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2524 10.8125H22.258V8.46874C22.258 8.43259 22.2464 8.40065 22.2394 8.36684L19.2524 10.8125Z",
    fill: "var(--ion-color-secondary)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01758 10.8125H11.031L14.4334 8H12.4483L9.01758 10.8125Z",
    fill: "var(--ion-color-secondary)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7417 22.5312C7.7417 22.7903 7.93191 23 8.16698 23H21.8326C22.0676 23 22.2578 22.7903 22.2578 22.5312V11.75H7.7417V22.5312ZM12.8734 14.0938C12.8734 13.9248 12.9556 13.7692 13.0889 13.6859C13.2223 13.6026 13.3859 13.6048 13.5175 13.6918L17.7703 16.5043C17.8982 16.589 17.9767 16.7414 17.9767 16.9062C17.9767 17.071 17.8982 17.2234 17.7703 17.3081L13.5175 20.1206C13.3858 20.2076 13.2221 20.2098 13.0889 20.1266C12.9556 20.0433 12.8734 19.8877 12.8734 19.7188V14.0938Z",
    fill: "var(--ion-background-color)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16698 8C7.93191 8 7.7417 8.20966 7.7417 8.46875V10.6955L11.031 8H8.16698Z",
    fill: "var(--ion-color-secondary)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7241 14.9218V18.8907L16.7252 16.9063L13.7241 14.9218Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStory);
export default __webpack_public_path__ + "static/media/story.b203656e.svg";
export { ForwardRef as ReactComponent };